import type { CurrentUserState } from '@/utils/user-helper';
import useUser from '@/ui/providers/userProvider';
import { useServerUserState } from '@/ui/providers/server-user-state-provider';

/**
 * The current user's login and club membership, or null while it is not known yet. Before the
 * client has checked the session, the server's answer (when the page has one) covers the render.
 */
export function useCurrentUserState(): CurrentUserState | null {
  const { isInitialized, isLoggedIn, isClubMember } = useUser();
  const serverUserState = useServerUserState();

  if (isInitialized) {
    return { isLoggedIn, isClubMember };
  }

  return serverUserState ?? null;
}
